import './sentry'; // must run first to capture import-time errors
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
// Self-hosted variable fonts (replaces the previous Google Fonts
// @import in index.css). Inter ships latin + cyrillic + greek
// subsets with the wght axis; Fraunces ships latin + vietnamese +
// latin-ext with the opsz (optical sizing) axis so headlines can
// settle into the display cut without loading multiple weight files.
import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/fraunces/opsz.css';
// Additional font-pairing options for admin Theme settings (PHASE 4) —
// see frontend/src/utils/theme.js FONT_PAIRINGS. Imported eagerly like
// the two above; the browser only fetches the actual woff2 files once a
// selected pairing's font-family is applied on the page.
import '@fontsource-variable/playfair-display/wght.css';
import '@fontsource-variable/source-sans-3/wght.css';
import '@fontsource-variable/manrope/wght.css';
// PHASE 7 — two more pairings for the admin Theme "look presets".
import '@fontsource-variable/space-grotesk/wght.css';
import '@fontsource-variable/dm-sans/wght.css';
import '@fontsource-variable/nunito/wght.css';
// Kristal starter theme: Bricolage Grotesque headings (opsz for display
// sizes), Figtree body.
import '@fontsource-variable/bricolage-grotesque/opsz.css';
import '@fontsource-variable/figtree/wght.css';
import './index.css';
// Liquid-glass surfaces; inert unless the theme's surfaceStyle is "glass".
import './styles/glass.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import './i18n/config'; // Initialize i18n

// Prevent browser scroll restoration from fighting our ScrollToTop component.
if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

const rootElement = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Something went wrong. Please refresh the page.</div>}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// #root may hold the server's plain crawler markup (SeoPageRenderer's
// `.ssr-page`). That is not React output, so it must never be hydrated:
// hydrating it throws React #418/#423 and re-renders anyway. createRoot
// replaces it on the first commit, so visitors never see an empty page.
ReactDOM.createRoot(rootElement).render(tree);

